(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("3gKOO", function(module, exports) {
const $26172ee410de0630$var$initFilterForm = ()=>{
    const filtrationForms = document.querySelectorAll(".f-filtration:not(.--inline)");
    filtrationForms.forEach((form)=>{
        const openFilter = form.querySelector(".--js-open-filter");
        const openFilterTitle = openFilter?.querySelector(".btn__title");
        const initTitle = openFilterTitle?.innerHTML ?? "";
        if (!openFilterTitle) return;
        openFilter?.addEventListener("click", ()=>{
            form.classList.toggle("--open");
            document.dispatchEvent(new Event("rangeReinit"));
            const title = openFilterTitle.innerHTML;
            const closeTitle = openFilter?.dataset.closeTitle ?? "";
            if (title == closeTitle) openFilterTitle.innerHTML = initTitle;
            else openFilterTitle.innerHTML = closeTitle;
        });
    });
};
$26172ee410de0630$var$initFilterForm();
document.addEventListener("filterReinit", $26172ee410de0630$var$initFilterForm);

});

})();
//# sourceMappingURL=filtration-form.28fca371.js.map
